<template>
  <div id="detail-delay-data-page">
    <b-card no-body class="h-100">
      <!-- header component -->
      <b-card-header>
        <div>
          <!-- title -->
          <b-card-title class="d-flex align-items-center">
            <i class="bi bi-info-circle"></i>
            <span style="margin-left: 5px">
              Detail Delay Berita pada <strong>{{ filter_data.portal_name }}</strong>
            </span>
          </b-card-title>
        </div>
        <!-- filter component -->
        <div
          class="d-flex flex-wrap gap-5px justify-content-end align-items-center"
        >
          <!-- back button -->
          <b-button variant="outline-info" @click="goBack()">
            <feather-icon icon="ArrowLeftCircleIcon" /> Kembali
          </b-button>
        </div>
      </b-card-header>
      <div class="mt-1">
        <!-- loader component -->
        <loader-component v-if="is_loading" />
        <!-- table component -->
        <table-component v-else :data="table_data" :is_pagination="false" />
        <paginationInfo
          :page="pagination.page"
          :items="pagination.items"
          :count="pagination.count"
          @update-value="paginationChanged"
        />
      </div>
    </b-card>
  </div>
</template>
<script>
import useJwt from "@/auth/jwt/useJwt";
import dataTable from "@/views/components/dataTable.vue";
import loader from "@/views/components/loader.vue";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
} from "bootstrap-vue";
import axios from "axios";
import paginationInfo from "@/views/components/paginationInfo.vue";

export default {
  name: "DelayDataDetail",
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardSubTitle,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    paginationInfo,
    "table-component": dataTable,
    "loader-component": loader,
  },
  data() {
    return {
      is_loading: true,
      full_data: [],
      filter_data: {
        portal_name: this.$route.query.portal_name,
        from_date: this.$route?.query?.from_date,
        to_date: this.$route?.query?.to_date,
        hour: this.$route?.query?.hour,
      },
      pagination: {
        page: 1,
        items: 10,
        count: 0,
      },
      table_data: {
        fields: [
          {
            key: "no",
            label: "no",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "1rem" },
          },
          {
            key: "title",
            label: "judul",
            sortable: true,
            thClass: "text-left",
            tdClass: "text-left",
          },
          {
            key: "url",
            label: "url",
            thClass: "text-center",
            tdClass: "text-center",
            thStyle: { width: "7%" },
          },
          {
            key: "date",
            label: "tanggal",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "timestamp",
            label: "timestamp",
            thClass: "text-justify",
            tdClass: "text-justify",
          },
        ],
        items: [],
      },
      cancel_token: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    paginationChanged(data) {
      this.pagination = data;
      // this.getData();
      this.updateTableData();
    },
    getData() {
      this.is_loading = true;
      if (this.cancel_token) {
        this.cancel_token.cancel("ERR_CANCELED");
      }
      this.cancel_token = axios.CancelToken.source();

      let params = {
        from_date: this.filter_data.from_date,
        to_date: this.filter_data.to_date,
        hour: this.filter_data.hour,
        name: this.filter_data.portal_name,
      };
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      let api = process.env.VUE_APP_API_URL + "stream/data/timestamp?" + query;

      useJwt.axiosIns
        .get(api, { cancelToken: this.cancel_token.token })
        .then((res) => {
          this.cancel_token.value = null;
          this.full_data = res?.data?.data[0].data || [];
          this.pagination.count = res?.data?.data[0].total || 0;
          this.updateTableData();
        })
        .catch((err) => {
          if (err.message != "ERR_CANCELED") {
            this.cancel_token.value = null;
          } else {
            this.cancel_token.value = "CANCELED";
          }
        })
        .finally(() => {
          if (!this.cancel_token.value) {
            this.is_loading = false;
          }
        });
    },
    updateTableData() {
      this.is_loading = true;
      const start = (this.pagination.page - 1) * this.pagination.items;
      const end = start + this.pagination.items;
      this.table_data.items = this.full_data.slice(start, end);
      this.is_loading = false;
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>
